interface PayTmDetailResponseType {
	customerId: string,
  email: string,
  phone: string,
  expiry: string,
   isExpired: boolean,
  paytmCustomerId: string,
  balance: string,
}

export const paytmDetailTransformer = (response:PayTmDetailResponseType) => ({
	customerId: response.customerId,
	email: response.email,
	phone: response.phone,
	expiry: response.expiry,
	isExpired: response.isExpired,
	paytmCustomerId: response.paytmCustomerId,
	balance: response.balance,
});
